import { useNavigate } from 'react-router-dom';
import { MessageSquare, Clock } from 'lucide-react';

export default function HistoryView({
  chatHistory,
  createNewChat,
  isDarkMode,
}) {
  const navigate = useNavigate();

  return (
    <div
      className={`w-full px-4 sm:px-6 py-4 overflow-y-auto transition-colors ${
        isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
      }`}
    >
      <div className="max-w-3xl mx-auto">
        {/* Header Section */}
        <div className="mb-6 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
          <div>
            <h2
              className={`text-lg sm:text-xl font-semibold ${
                isDarkMode ? 'text-white' : 'text-gray-800'
              } mb-1 sm:mb-0`}
            >
              Chat History
            </h2>
            <p
              className={`text-sm ${
                isDarkMode ? 'text-gray-400' : 'text-gray-600'
              }`}
            >
              View and resume your previous conversations
            </p>
          </div>
          <button
            onClick={createNewChat}
            className="w-full sm:w-auto px-4 py-2 bg-brand text-white rounded-lg hover:bg-brand flex items-center justify-center text-sm"
          >
            <MessageSquare className="h-4 w-4 mr-2" />
            New Chat
          </button>
        </div>

        {/* Chat History List */}
        <div className="space-y-3">
          {chatHistory.map((chat) => (
            <div
              key={chat.id}
              onClick={() => navigate(`/app/chat/${chat.id}`)}
              className={`border rounded-lg p-4 cursor-pointer shadow-sm transition-colors ${
                isDarkMode
                  ? 'bg-gray-800 border-gray-600 hover:bg-gray-700'
                  : 'bg-white border-gray-200 hover:bg-gray-50'
              }`}
            >
              <div className="flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
                <h3
                  className={`font-medium text-base sm:text-lg ${
                    isDarkMode ? 'text-white' : 'text-gray-800'
                  }`}
                >
                  {chat.title}
                </h3>
                <div className={isDarkMode ? 'text-gray-400' : 'text-gray-500'}>
                  {chat.date}
                </div>
              </div>
              <div
                className={`flex items-center mt-2 text-sm ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                }`}
              >
                <MessageSquare className="h-4 w-4 mr-1" />
                <span>{chat.messages} messages</span>
              </div>
            </div>
          ))}

          {/* No History Case */}
          {chatHistory.length === 0 && (
            <div className="text-center py-12">
              <Clock
                className={`h-12 w-12 mx-auto mb-3 ${
                  isDarkMode ? 'text-gray-500' : 'text-gray-400'
                }`}
              />
              <h3
                className={`text-lg font-medium mb-1 ${
                  isDarkMode ? 'text-white' : 'text-gray-700'
                }`}
              >
                No Chat History Yet
              </h3>
              <p
                className={`text-sm ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-500'
                }`}
              >
                Start a new conversation to see it here
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
